import { Route } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { AdminDeleteAccountComponent } from './admin-delete-account/admin-delete-account.component';
import { ContactEmailComponent } from './contact-email/contact-email.component';
import { LinkPolicyComponent } from './link-policy/link-policy.component';
import { AuthorizeGuard } from './guards/authorize.guard';
import { BalanceDetailsComponent } from './balance-details/balance-details.component';
import { MobileRedirectComponent } from './mobile-redirect/mobile-redirect.component';
import { ManageAlertPreferencesComponent } from 'libs/account/src/lib/manage-alerts-preferences/manage-alert-preferences.component';
import { AdditionalDriversInfoComponent } from '../app/additional-drivers-info/additional-drivers-info.component';
import { AdditionalDriversDetailsComponent } from '../app/additional-drivers-details/additional-drivers-details.component';
import { AdditionalDriversRspnComponent } from '../app/additional-drivers-rspn/additional-drivers-rspn.component';
import { QuestionnaireRenewalDriverErrorComponent } from './questionnaire-renewal-driver-error/questionnaire-renewal-driver-error.component';
import { MobileAppLandingComponent } from "./mobile-app-landing/mobile-app-landing.component";
import { MobileAppDownloadComponent } from "./mobile-app-download/mobile-app-download.component";
import { JpmMaintenanceComponent } from './jpm-maintenance/jpm-maintenance.component';
import { MobileAppRedirectComponent } from "./mobile-app-redirect/mobile-app-redirect.component";
const ɵ0 = () => import("./../../../../libs/claims-payment-subro/src/lib/claims-payment-subro.module.ngfactory").then(m => m.ClaimsPaymentSubroModuleNgFactory), ɵ1 = { 'tealium': { 'subSection': 'eService' } }, ɵ2 = () => import("./../../../../libs/login/src/lib/login.module.ngfactory").then(m => m.LoginModuleNgFactory), ɵ3 = { 'tealium': 'admin' }, ɵ4 = { 'tealium': { 'subSection': 'Home' } }, ɵ5 = () => import("./../../../../libs/billing/src/lib/billing.module.ngfactory").then(m => m.BillingModuleNgFactory), ɵ6 = { 'tealium': { 'subSection': 'Payments' } }, ɵ7 = () => import("./../../../../libs/policy/src/lib/policy.module.ngfactory").then(m => m.PolicyModuleNgFactory), ɵ8 = { 'tealium': { 'subSection': 'Payments' } }, ɵ9 = () => import("./../../../../libs/documents/src/lib/documents.module.ngfactory").then(m => m.DocumentsModuleNgFactory), ɵ10 = { 'tealium': { 'subSection': 'Documents' } }, ɵ11 = () => import("./../../../../libs/address/src/lib/address.module.ngfactory").then(m => m.AddressModuleNgFactory), ɵ12 = { 'tealium': { 'subSection': 'Policy' } }, ɵ13 = () => import("./../../../../libs/claims/src/lib/claims.module.ngfactory").then(m => m.ClaimsModuleNgFactory), ɵ14 = { 'tealium': { 'subSection': 'Claims' } }, ɵ15 = () => import("./../../../../libs/payment/src/lib/payment.module.ngfactory").then(m => m.PaymentModuleNgFactory), ɵ16 = { 'tealium': { 'subSection': 'Payments:Make a Payment' } }, ɵ17 = () => import("./../../../../libs/account/src/lib/account.module.ngfactory").then(m => m.AccountModuleNgFactory), ɵ18 = { 'tealium': { 'subSection': 'Account' } }, ɵ19 = { 'tealium': { 'subSection': 'Link a Policy' } }, ɵ20 = () => import("./../../../../libs/edit-coverages/src/lib/edit-coverages.module.ngfactory").then(m => m.EditCoveragesModuleNgFactory), ɵ21 = { 'tealium': { 'subSection': 'Policy' } }, ɵ22 = () => import("./../../../../libs/add-driver/src/lib/add-driver.module.ngfactory").then(m => m.AddDriverModuleNgFactory), ɵ23 = () => import("./../../../../libs/add-driver/src/lib/add-driver.module.ngfactory").then(m => m.AddDriverModuleNgFactory), ɵ24 = () => import("./../../../../libs/mortgage/src/lib/mortgage.module.ngfactory").then(m => m.MortgageModuleNgFactory), ɵ25 = () => import("./../../../../libs/mortgage/src/lib/mortgage.module.ngfactory").then(m => m.MortgageModuleNgFactory), ɵ26 = () => import("./../../../../libs/mortgage/src/lib/mortgage.module.ngfactory").then(m => m.MortgageModuleNgFactory), ɵ27 = () => import("./../../../../libs/endorsement/src/lib/endorsement.module.ngfactory").then(m => m.EndorsementModuleNgFactory), ɵ28 = { 'tealium': { 'subSection': 'Policy' } }, ɵ29 = () => import("./../../../../libs/features/personal-auto/src/lib/features-personal-auto.module.ngfactory").then(m => m.FeaturesPersonalAutoModuleNgFactory), ɵ30 = () => import("./../../../../libs/quickpay/src/lib/quickpay.module.ngfactory").then(m => m.QuickpayModuleNgFactory), ɵ31 = { 'tealium': { 'subSection': 'Payments' } }, ɵ32 = () => import("./../../../../libs/iva/src/lib/iva.module.ngfactory").then(m => m.IvaModuleNgFactory), ɵ33 = { 'tealium': { 'subSection': 'Documents' } };
const routes = [
    {
        path: 'claims/subro',
        loadChildren: ɵ0
    },
    {
        path: 'eservice',
        data: ɵ1,
        children: [
            {
                path: '',
                loadChildren: ɵ2
            },
            {
                path: 'admin/activity',
                component: AdminHomeComponent,
                canActivate: [AuthorizeGuard],
                data: ɵ3
            },
            {
                path: 'admin/activity/delete',
                canActivate: [AuthorizeGuard],
                component: AdminDeleteAccountComponent
            },
            {
                path: 'mobile/redirect',
                component: MobileRedirectComponent
            },
            {
                path: 'alerts/preferences/:userId',
                component: ManageAlertPreferencesComponent
            },
            {
                path: 'home',
                canActivate: [AuthorizeGuard],
                canActivateChild: [AuthorizeGuard],
                component: HomeComponent,
                children: [
                    {
                        path: '',
                        component: LandingComponent,
                        data: ɵ4
                    },
                    {
                        path: 'billing',
                        loadChildren: ɵ5,
                        data: ɵ6
                    },
                    {
                        path: 'policy',
                        loadChildren: ɵ7,
                        data: ɵ8
                    },
                    {
                        path: 'documents',
                        loadChildren: ɵ9,
                        data: ɵ10
                    },
                    {
                        path: 'address',
                        loadChildren: ɵ11,
                        data: ɵ12
                    },
                    {
                        path: 'claims',
                        loadChildren: ɵ13,
                        data: ɵ14
                    },
                    {
                        path: 'payment',
                        loadChildren: ɵ15,
                        data: ɵ16
                    },
                    {
                        path: 'account',
                        loadChildren: ɵ17,
                        data: ɵ18
                    },
                    {
                        path: 'contact',
                        children: [
                            {
                                path: 'email',
                                component: ContactEmailComponent
                            }
                        ]
                    },
                    {
                        path: 'jpmmaintenance',
                        component: JpmMaintenanceComponent,
                    },
                    {
                        path: 'balance',
                        children: [
                            {
                                path: 'details',
                                component: BalanceDetailsComponent
                            }
                        ]
                    },
                    {
                        path: 'link-a-policy',
                        component: LinkPolicyComponent,
                        data: ɵ19
                    },
                    {
                        path: 'edit-coverages',
                        loadChildren: ɵ20,
                        data: ɵ21
                    },
                    {
                        path: 'add-driver',
                        loadChildren: ɵ22,
                    },
                    {
                        path: 'edit-driver',
                        loadChildren: ɵ23,
                    },
                    {
                        path: 'add-mortgage',
                        loadChildren: ɵ24,
                    },
                    {
                        path: 'edit-mortgage',
                        loadChildren: ɵ25,
                    },
                    {
                        path: 'replace-mortgage',
                        loadChildren: ɵ26,
                    },
                    {
                        path: 'endorsement',
                        loadChildren: ɵ27,
                        data: ɵ28
                    },
                    {
                        path: 'auto-endorsement',
                        loadChildren: ɵ29,
                    }
                ]
            },
            {
                path: 'app-landing', component: MobileAppLandingComponent
            },
            {
                path: 'app-download', component: MobileAppDownloadComponent
            },
            {
                path: 'app-redirect', component: MobileAppRedirectComponent
            },
            {
                path: 'app', redirectTo: 'app-download', pathMatch: 'full'
            }
        ]
    },
    {
        path: 'qpay',
        loadChildren: ɵ30,
        data: ɵ31
    },
    {
        path: 'iva',
        loadChildren: ɵ32,
        data: ɵ33
    },
    { path: 'eway/route/local/ui', redirectTo: 'eservice', pathMatch: 'full' },
    {
        path: 'questionnaire/renewal',
        children: [{
                path: 'driver',
                component: AdditionalDriversInfoComponent
            },
            {
                path: 'driver/review',
                canActivate: [AuthorizeGuard],
                component: AdditionalDriversDetailsComponent
            },
            {
                path: 'driver/confirmation',
                canActivate: [AuthorizeGuard],
                component: AdditionalDriversRspnComponent
            },
            {
                path: 'driver/error',
                component: QuestionnaireRenewalDriverErrorComponent
            }]
    },
    {
        path: '', redirectTo: 'eservice', pathMatch: 'full'
    },
    {
        path: '**', redirectTo: 'eservice', pathMatch: 'full'
    }
];
export class EserviceRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33 };
